(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["td-returning-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('td-rh-carousel')) {
    class TdRhCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.td-rh__grid');
        if (!this.track) return;
        this.slides = Array.from(this.track.children);
        this.dots = Array.from(this.querySelectorAll('.td-rh__dot'));
        this.pauseBtn = this.querySelector('.td-rh__pause');
        this.index = 0;
        this.userPaused = false;
        this.interval = Math.max(3, parseInt(this.dataset.interval, 10) || 6) * 1000;
        this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.dots.forEach((dot, i) => dot.addEventListener('click', () => { this.go(i); this.start(); }));
        if (this.pauseBtn) {
          if (this.reduce) this.pauseBtn.hidden = true;
          this.pauseBtn.addEventListener('click', () => this.togglePause());
        }
        this.track.addEventListener('scroll', () => {
          clearTimeout(this.scrollTimer);
          this.scrollTimer = setTimeout(() => this.sync(), 120);
        }, { passive: true });
        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', () => this.start());
        this.addEventListener('touchstart', () => { this.userPaused = true; this.stop(); this.updatePauseBtn(); }, { passive: true });

        this.onVisibility = () => (document.hidden ? this.stop() : this.start());
        document.addEventListener('visibilitychange', this.onVisibility);
        this.onBlockSelect = (e) => {
          const i = this.slides.indexOf(e.target);
          if (i > -1) { this.stop(); this.go(i); }
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);

        this.start();
      }

      disconnectedCallback() {
        this.stop();
        document.removeEventListener('visibilitychange', this.onVisibility);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      canAuto() {
        return this.dataset.autoplay === 'true' && !this.reduce && !this.userPaused && this.slides.length > 1;
      }

      start() {
        this.stop();
        if (!this.canAuto()) return;
        this.timer = setInterval(() => {
          if (this.offsetParent !== null && !document.hidden) this.go((this.index + 1) % this.slides.length);
        }, this.interval);
      }

      stop() {
        clearInterval(this.timer);
      }

      togglePause() {
        this.userPaused = !this.userPaused;
        this.updatePauseBtn();
        this.start();
      }

      updatePauseBtn() {
        if (!this.pauseBtn) return;
        const paused = this.userPaused;
        this.pauseBtn.setAttribute('aria-label', paused ? this.pauseBtn.dataset.labelPlay : this.pauseBtn.dataset.labelPause);
        this.pauseBtn.querySelector('span').textContent = paused ? '▶' : '❚❚';
      }

      go(i) {
        this.index = i;
        this.track.scrollTo({ left: this.slides[i].offsetLeft, behavior: this.reduce ? 'auto' : 'smooth' });
        this.updateDots();
      }

      sync() {
        const w = this.track.clientWidth || 1;
        this.index = Math.min(this.slides.length - 1, Math.round(this.track.scrollLeft / w));
        this.updateDots();
      }

      updateDots() {
        this.dots.forEach((d, i) => d.setAttribute('aria-current', i === this.index ? 'true' : 'false'));
      }
    }
    customElements.define('td-rh-carousel', TdRhCarousel);
  }

  } catch(e) { console.error(e); }
})();
})();
